
import "../styles/global.scss"
import "../styles/styles.scss"

import { animate, inView, stagger } from "motion"
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'
import MiniMasonry from "minimasonry"


function adjustViewPortHeight() {
    document.documentElement.style.setProperty('--viewport-height', `${window.visualViewport.height}px`)
}

adjustViewPortHeight();
window.addEventListener('resize', () => { adjustViewPortHeight(); });


// Lightbox
const lightbox = new PhotoSwipeLightbox({
    gallery: '.lm-gallery',
    children: '.image a',
    pswpModule: () => import('photoswipe')
})
lightbox.init();


const WOOlightbox = new PhotoSwipeLightbox({
    gallery: '.woo-lm-gallery',
    children: '.woocommerce-product-gallery__image a',
    pswpModule: () => import('photoswipe')
})
WOOlightbox.init();


// Animations
var animationSelector = ".wp-block-image, .wp-block-group, .wp-block-gallery, .wp-block-paragraph, .wp-block-heading, #content h1, .wp-block-list, .wp-block-jeremybasolo-faq-block, .product-teaser, .entry-summary, .entry-images"
var css = animationSelector + ', .lm-gallery .image { opacity: 0; }';


if(document.querySelector('.lm-gallery')) {

    // Masonry
    window.addEventListener("load", (event) => {

        var baseWidth = 240

        if($(window).width() < 600) {
            baseWidth = 130
        }
        
        var masonry = new MiniMasonry({
            container: '.lm-gallery',
            baseWidth: baseWidth,
            gutter: 20
        })

        masonry.layout()
        
    })
}

window.addEventListener("load", (event) => {

    

    if(document.querySelector('#main-hero .card')) {
        
        animate('#main-hero .card', { 
            opacity: 1,
            transform: ['translateY(30px)', 'translateY(0)']
        }, { duration: .35, delay: 0 })
        
    }

    inView(animationSelector, (element) => {
        animate(element, { 
            opacity: 1, 
            transform: ['translateY(20px)', 'translateY(0)'] 
        }, { duration: .35, delay: .15 })
    })

    inView('.lm-gallery .image', (element) => {
        animate(element, { 
            opacity: 1, 
            top: ['20px', '0'] 
        }, { duration: .35, delay: 0.15 })
    })


})


if(document.body.classList.contains('home')) {
    function adjustMainNav() {
        if(window.scrollY > 40) {
            document.getElementById('main-header').classList.add('no-hero');
        } else {
            document.getElementById('main-header').classList.remove('no-hero');
        }
    }
    adjustMainNav()
    window.addEventListener("scroll", (event) => {
        adjustMainNav()
    })
}

document.getElementById('menu-trigger').addEventListener('click', (ev) => {
    ev.target.classList.toggle('active')
    document.getElementById('nav-main-mobile').classList.toggle('active')
    if(document.body.classList.contains('home')) {
        if(document.getElementById('nav-main-mobile').classList.contains('active')) {
            document.getElementById('main-header').classList.add('no-hero');
        } else {
            if(window.scrollY < 40) {
                document.getElementById('main-header').classList.remove('no-hero');
            }
        }
    }
})

if(document.getElementById('scroll-down')) {
    document.getElementById('scroll-down').addEventListener('click', (ev) => {
        var scrollTo = document.getElementById('content-container').offsetTop
        scrollTo = scrollTo - document.getElementById('main-header').clientHeight
        window.scrollTo({
            top: scrollTo,
            left: 0,
            behavior: "smooth",
          });
          
    })
}

setTimeout(() => {
    document.querySelectorAll('.cart-mini-contents .count').forEach((element) => {
        if(Number(element.textContent) > 0) {
            element.classList.add('active')
        } else {
            element.classList.remove('active')
        }
    })
}, 350)

document.addEventListener("DOMContentLoaded", function() {
	var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  
	if ("IntersectionObserver" in window) {
	  var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
		entries.forEach(function(video) {
		  if (video.isIntersecting) {
			for (var source in video.target.children) {
			  var videoSource = video.target.children[source];
			  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				videoSource.src = videoSource.dataset.src;
			  }
			}
  
			video.target.load();
			video.target.classList.remove("lazy");

			video.target.nextElementSibling.addEventListener('click', function(ev) {
				ev.preventDefault();
				video.target.muted = !video.target.muted;
				this.classList.toggle('active');
			});

			lazyVideoObserver.unobserve(video.target);
		  }
		});
	  });
  
	  lazyVideos.forEach(function(lazyVideo) {
		lazyVideoObserver.observe(lazyVideo);
	  });
	}
});